import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StorageRoutingModule } from './storage-routing.module';
import { StorageComponent } from './components/scripts/storage.component';
import { BlobStorageService } from '../shared/services/blobStorage.service';
import { TreeModule } from 'angular-tree-component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    StorageRoutingModule,
    TreeModule.forRoot()
  ],
  declarations: [
    StorageComponent
  ],
  providers: [
    BlobStorageService
  ],
  entryComponents: []
})

export class StorageModule { }



// WEBPACK FOOTER //
// ./src/app/storage/storage.module.ts